export const SET_SCORING_DETAILS = 'scoring/SET_SCORING_DETAILS';
export const SET_STATUS_CODE_TYPES = 'scoring/SET_STATUS_CODE_TYPES';
